import React from 'react';
import Circular from './circular';
import Bar from './bar';
import Evolution from './evolutionGraph';

const position = obj => {
  if (obj.value || obj.value >= 0) {
    let total = 164 * obj.value;
    total /= obj.total;
    total += 62;
    return total;
  }
  return 62;
};

const colorSeverityItem = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return 'gris';
  } else if (severety.toUpperCase() === 'HIGHRISK') {
    return 'red';
  } else if (severety.toUpperCase() === 'OUTOFRISK') {
    return 'green';
  }
  return 'yellow';
};

const Main = props => {
  return (
    <section
      role="button"
      tabIndex={0}
      onClick={props.link}
      className="container-main-principal flex click fix-bad-tour-position fix-bottom"
    >
      <section
        className={`module-box-circular`}
      >
        <Circular
          data={props.datos}
          language={props.language}
          graphColorRange={props.graphColorRange}
        />
        <Bar
          distribution={props.datos.distributions}
          width={'circular'}
          text
          language={props.language}
          graphColorRange={props.graphColorRange}
          showTravelInfo
          drivenKms={props.datos.amountDrivenKms}
          drivenHours={props.datos.amountDrivenHours}
        />
      </section>
      <section className="evolution">
        {props.datos.dailyBehaviorGradeList.length > 0 && (
          <Evolution
            tooltip={props.tooltip}
            graphColorRange={props.graphColorRange}
            data={props.datos.dailyBehaviorGradeList}
            period={props.datos.period}
          />
        )}
        {props.datos.dailyBehaviorGradeList.length > 0 && (
          <span
            className={colorSeverityItem(
              props.datos.dailyBehaviorGradeList[props.datos.dailyBehaviorGradeList.length - 1].severity
            ) + " topLastIndicator"}
            style={{
              bottom: position({
                total: 100,
                value: props.datos.dailyBehaviorGradeList[props.datos.dailyBehaviorGradeList.length - 1].behaviorGrade
              })
            }}
          >
            {props.datos.dailyBehaviorGradeList[props.datos.dailyBehaviorGradeList.length - 1].behaviorGrade}
          </span>
        )}
      </section>
    </section>
  );
};
export default Main;



// WEBPACK FOOTER //
// ./source/client/components/summary_behaviour/main.jsx